import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    alignItems: 'center',
    backgroundColor: theme.palette.background.container,
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    marginBottom: '15px',
    padding: '8px 16px 8px 12px',
    width: '100%',
  },

  LOW: {
    borderLeft: theme.palette.itemList.border.low,
  },
  HIGH: {
    borderLeft: theme.palette.itemList.border.high,
  },
  MEDIUM: {
    borderLeft: theme.palette.itemList.border.medium,
  },
  URGENT: {
    borderLeft: theme.palette.itemList.border.urgent,
  },
  normal: {
    borderLeft: theme.palette.itemList.border.normal,
  },

  textSecondary: {
    color: theme.palette.text.subtitle,
    lineHeight: 1,
    textAlign: 'start',
  },

  header: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 4,
  },

  collapsible: {
    alignItems: 'flex-start !important',
    flexDirection: 'column',
    marginBottom: 0,
  },

  collapsibleContainer: {
    marginBottom: 0,
  },

  footer: {
    '& p': {
      lineHeight: 1.2,
    },
  },

  footerRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  content: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 8,
  },
}));

const collapseCardStyles = makeStyles((theme) => ({
  root: {
    marginBottom: 15,
    '& button': {
      borderRadius: 4,
    },
  },
  box: {
    border: 0,
    borderTop: 0,
    marginTop: 0,
  },
  boxContainer: {
    maxHeight: 'fit-content',
    overflowY: 'none',
  },
  buttonClass: {
    backgroundColor: theme.palette.background.input,
    boxShadow: 'none',
    color: theme.palette.secondary.dark,
    padding: 0,
    textTransform: 'capitalize',
    fontSize: '13px',
    '&:hover': {
      backgroundColor: theme.palette.background.input,
      boxShadow: 'none',
      color: theme.palette.secondary.dark,
    },

    '& .MuiButton-endIcon': {
      padding: 15,
      marginLeft: 'auto',
      marginRight: 0,
    },
  },
}));

export { useStyles, collapseCardStyles };
